import React, { useEffect, useState } from 'react';
import { ZapIcon } from 'lucide-react';
const TOTAL_SECONDS = 34 * 60 + 26;
function pad(value: number): string {
  return value.toString().padStart(2, '0');
}
export function CountdownBar() {
  const [remaining, setRemaining] = useState<number>(TOTAL_SECONDS);
  useEffect(() => {
    const id = window.setInterval(() => {
      setRemaining(prev => prev <= 1 ? TOTAL_SECONDS : prev - 1);
    }, 1000);
    return () => window.clearInterval(id);
  }, []);
  const units: Array<{
    value: number;
    suffix: string;
  }> = [{
    value: Math.floor(remaining / 3600),
    suffix: 'h'
  }, {
    value: Math.floor(remaining % 3600 / 60),
    suffix: 'min'
  }, {
    value: remaining % 60,
    suffix: 'sec'
  }];
  return <div className="sticky top-0 z-50 w-full bg-primary text-primary-foreground" data-id="element-41" data-mp="28g6xkasn6mly">
      <div className="mx-auto flex max-w-5xl flex-nowrap items-center justify-center gap-x-2 whitespace-nowrap px-3 py-2 text-[9px] font-bold uppercase tracking-[0.1em] sm:px-4 sm:py-2.5 sm:text-[11px] sm:tracking-[0.14em]" data-id="element-42" data-mp="ant9o4pok1xp">
        <ZapIcon className="h-3 w-3 shrink-0 fill-current sm:h-3.5 sm:w-3.5" aria-hidden="true" data-id="element-43" data-mp="13cphk2dq4mdy" />
        <span className="sm:hidden" data-id="element-44" data-mp="18ar3cv2jazt4">Offre -95% expire dans&nbsp;:</span>
        <span className="hidden sm:inline" data-id="element-45" data-mp="uf5eqp07qi18">
          Offre de lancement&nbsp;: économisez 95% si vous commandez avant&nbsp;:
        </span>
        <span className="flex items-center gap-1 tabular-nums" aria-live="off" data-id="element-46" data-mp="1m4s39s582sv2">
          {units.map((unit, index) => <span key={unit.suffix} className="flex items-center gap-1" data-id="element-47" data-mp="1r3uy6jrhnipb" data-mpi={index}>
              <span className="text-xs font-extrabold tracking-normal sm:text-base" data-id="element-48" data-mp="1dcgcu6a3z5f3">
                {pad(unit.value)}
              </span>
              <span className="text-[8px] tracking-normal text-primary-foreground/70 sm:text-[9px]" data-id="element-49" data-mp="1hch2yo6kl51z">
                {unit.suffix}
              </span>
              {index < units.length - 1 && <span className="text-primary-foreground/50 sm:px-1" data-id="element-50" data-mp="29uw7a0mbouml">:</span>}
            </span>)}
        </span>
      </div>
    </div>;
}